import { Theme, Users } from "@just-in-types";
import * as React from "react";
import styled from "react-emotion";
import { connect } from "react-redux";
import Button from "../components/Button";
import Column from "../components/Column";
import Container from "../components/Container";
import Logo from "../components/Logo";
import NextButton from "../components/NextButton";
import ResetButton from "../components/ResetButton";
import Row from "../components/Row";
import Title from "../components/Title";
import ErrorBoundary from "../hoc/withErrorBoundary";
import { RouteComponentProps } from "../Site";
import { navigateToNext, NavigateToNext, setUserValue, SetUserValue } from "../store/actions";
import { IState } from "../store/reducers";
import { IStrings } from "../store/reducers/strings";

interface ICovidQuestionsDispatchProps {
  onNavigateToNext: NavigateToNext;
  onSetUserValue: SetUserValue;
}

type CovidQuestionsOwnProps = RouteComponentProps;

interface ICovidQuestionsStateProps {
  languageStrings: IStrings;
  theme: Theme.Props;
  user: Users.User;
}

type CovidQuestionsProps = ICovidQuestionsDispatchProps & CovidQuestionsOwnProps & ICovidQuestionsStateProps;

interface ICovidQuestionsState {
  closeContact: boolean | null;
  denyEntry: boolean;
  experiencedSymptoms: boolean | null;
  traveled: boolean | null;
}

const CovidQuestionsContainer = styled(Container)`
  grid-template-rows: 20vh 55vh 25vh;
`;

const DisclaimerText = styled("div")`
  color: ${(props: { color: string }) => props.color};
  text-shadow: 1px 1px 1px black;
  font-size: 14px;
  width: 400px;
`;

class CovidQuestions extends React.Component<CovidQuestionsProps, ICovidQuestionsState> {
  public constructor(props) {
    super(props);
    this.state = {
      closeContact: null,
      denyEntry: false,
      experiencedSymptoms: null,
      traveled: null,
    };
  }
  public handleEnter = (result) => {
    const { onNavigateToNext, onSetUserValue } = this.props;

    onSetUserValue({ name: "covidquestions", value: result });

    onNavigateToNext();
  };

  public areAnyAnswersYes = (): string => {
    const { closeContact, experiencedSymptoms, traveled } = this.state;
    if (closeContact || experiencedSymptoms || traveled) {
      return "yes";
    }
    return "no";
  };

  public render() {
    const {
      languageStrings: strings,
      theme: { colors, logo },
      site: {
        kioskUiBackgroundColor,
        kioskUiTextColor,
        kioskUiTitleTextColor,
        kioskUiButtonPrimaryColor,
        kioskUiButtonErrorColor,
        kioskUiButtonSuccessColor,
      },
    } = this.props;

    const { closeContact, denyEntry, experiencedSymptoms, traveled } = this.state;

    if (!denyEntry) {
      return (
        <ErrorBoundary>
          <CovidQuestionsContainer style={{ background: kioskUiBackgroundColor }}>
            <Row align="center" justify="center">
              <Logo logo={logo} />
            </Row>
            <Column align="center" justify="space-around">
              <Title color={kioskUiButtonSuccessColor ? kioskUiButtonSuccessColor : colors.success} size="2rem">
                {strings.covidDisclaimer}
              </Title>
              <Row align="center" justify="center">
                <Title color={kioskUiTitleTextColor ? kioskUiTitleTextColor : colors.secondary} size="1.5rem">
                  {strings.closeContactWithCovidLast14Days}
                </Title>
                <Button
                  bg={
                    closeContact === true
                      ? kioskUiButtonPrimaryColor
                        ? kioskUiButtonPrimaryColor
                        : colors.primary
                      : kioskUiButtonErrorColor
                      ? kioskUiButtonErrorColor
                      : colors.error
                  }
                  size="2.5rem"
                  onClick={() => this.setState({ closeContact: true })}
                >
                  {strings.yes}
                </Button>
                <Button
                  bg={
                    closeContact === false
                      ? kioskUiButtonPrimaryColor
                        ? kioskUiButtonPrimaryColor
                        : colors.primary
                      : kioskUiButtonSuccessColor
                      ? kioskUiButtonSuccessColor
                      : colors.success
                  }
                  size="2.5rem"
                  onClick={() => this.setState({ closeContact: false })}
                >
                  No
                </Button>
              </Row>
              <Row align="center" justify="center">
                <Title color={kioskUiTitleTextColor ? kioskUiTitleTextColor : colors.secondary} size="1.5rem">
                  {strings.experiencedFluLikeSymptoms}
                </Title>
                <Button
                  bg={
                    experiencedSymptoms === true
                      ? kioskUiButtonPrimaryColor
                        ? kioskUiButtonPrimaryColor
                        : colors.primary
                      : kioskUiButtonErrorColor
                      ? kioskUiButtonErrorColor
                      : colors.error
                  }
                  size="2.5rem"
                  onClick={() => this.setState({ experiencedSymptoms: true })}
                >
                  {strings.yes}
                </Button>
                <Button
                  bg={
                    experiencedSymptoms === false
                      ? kioskUiButtonPrimaryColor
                        ? kioskUiButtonPrimaryColor
                        : colors.primary
                      : kioskUiButtonSuccessColor
                      ? kioskUiButtonSuccessColor
                      : colors.success
                  }
                  size="2.5rem"
                  onClick={() => this.setState({ experiencedSymptoms: false })}
                >
                  No
                </Button>
              </Row>
              <Row align="center" justify="center">
                <Title color={kioskUiTitleTextColor ? kioskUiTitleTextColor : colors.secondary} size="1.5rem">
                  {strings.traveledLast14Days}
                </Title>
                <Button
                  bg={
                    traveled === true
                      ? kioskUiButtonPrimaryColor
                        ? kioskUiButtonPrimaryColor
                        : colors.primary
                      : kioskUiButtonErrorColor
                      ? kioskUiButtonErrorColor
                      : colors.error
                  }
                  size="2.5rem"
                  onClick={() => this.setState({ traveled: true })}
                >
                  {strings.yes}
                </Button>
                <Button
                  bg={
                    traveled === false
                      ? kioskUiButtonPrimaryColor
                        ? kioskUiButtonPrimaryColor
                        : colors.primary
                      : kioskUiButtonSuccessColor
                      ? kioskUiButtonSuccessColor
                      : colors.success
                  }
                  size="2.5rem"
                  onClick={() => this.setState({ traveled: false })}
                >
                  No
                </Button>
              </Row>
            </Column>
            {closeContact !== null && experiencedSymptoms !== null && traveled !== null ? (
              this.areAnyAnswersYes() === "yes" ? (
                <Button
                  bg={kioskUiButtonPrimaryColor ? kioskUiButtonPrimaryColor : colors.primary}
                  size="2.5rem"
                  onClick={() => this.setState({ denyEntry: true })}
                >
                  Next/Finish
                </Button>
              ) : (
                <NextButton
                  bg={kioskUiButtonSuccessColor ? kioskUiButtonSuccessColor : colors.success}
                  disabled={false}
                  name="covidquestions"
                  value={this.areAnyAnswersYes()}
                />
              )
            ) : (
              ""
            )}
          </CovidQuestionsContainer>
        </ErrorBoundary>
      );
    } else {
      return (
        <ErrorBoundary>
          <CovidQuestionsContainer>
            <Row align="center" justify="center">
              <Logo logo={logo} />
            </Row>
            <Column align="center" justify="space-around">
              <Title color={kioskUiButtonErrorColor ? kioskUiButtonErrorColor : colors.error} size="3rem">
                {strings.covidEntryDenied}
              </Title>
              <NextButton
                bg={kioskUiButtonSuccessColor ? kioskUiButtonSuccessColor : colors.success}
                disabled={false}
                name="covidquestions"
                skipToEnd={true}
                value={this.areAnyAnswersYes()}
              />
            </Column>
          </CovidQuestionsContainer>
        </ErrorBoundary>
      );
    }
  }
}

const mapStateToProps = ({ router: { languageStrings }, theme, user }: IState) => ({
  languageStrings,
  theme,
  user,
});

const mapDispatchToProps = {
  onNavigateToNext: navigateToNext,
  onSetUserValue: setUserValue,
};

export default connect<ICovidQuestionsStateProps, ICovidQuestionsDispatchProps>(
  mapStateToProps,
  mapDispatchToProps
)(CovidQuestions);



// WEBPACK FOOTER //
// ./src/views/CovidQuestions.tsx